export function sendOfferButtonText(
  offerRequisitionFlowEnabled: boolean,
): string {
  return offerRequisitionFlowEnabled ? 'Request Offer Approval' : 'Send Offer';
}

export function sendOfferButtonIcon(
  offerRequisitionFlowEnabled: boolean,
): string {
  return offerRequisitionFlowEnabled
    ? 'bi-file-medical'
    : 'bi-file-earmark-medical';
}
